import axiosInstance from '@/utils/api.js'

var state = {
  onlineUpdate: [],
  currencies: []
}

var getters = {
  ONLINE_UPDATE: (state) => {
    return state.onlineUpdate
  },
  CURRENCIES: (state) => {
    return state.currencies
  }
}

var mutations = {
  SET_ONLINE_UPDATE: (state, payload) => {
    state.onlineUpdate = payload
  },
  SET_CURRENCIES: (state, payload) => {
    state.currencies = payload
  }
}

var actions = {
  GET_CURRENCIES: async (context, payload) => {
    let result = await axiosInstance.get('/referencebooks/currencies')
    if (result.status === 200) {
      context.commit('SET_CURRENCIES', result.data)
    }
  },
  GET_ONLINE_UPDATE: async (context, payload) => {
    let result = await axiosInstance.get('/reports/currency_rate_rbc?id=' + payload, {timeout: 45000})
    context.commit('SET_ONLINE_UPDATE', result.data)
  },
  CREATE_CURRENCIES: (context, payload) => {
    return axiosInstance.post('/referencebooks/currencies', payload)
  },
  UPDATE_CURRENCIES: (context, payload) => {
    return axiosInstance.put('/referencebooks/currencies', payload)
  },
  DELETE_CURRENCIES: (context, payload) => {
    return axiosInstance.delete('/referencebooks/currencies?currency_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/referencebooks/currencies.js